module.exports = __webpack_public_path__ + "static/media/em-227.7a54819f.png";